const HEX_BYTES = Array.from({length: 256}, (_, i) =>
  i.toString(16).padStart(2, '0')
);

/**
 * Hashes UTF-16 code units with FNV-1a 64-bit semantics.
 *
 * This intentionally matches `fnv-plus.fast1a64`, including its treatment of
 * non-ASCII strings, so existing browser cache filenames remain valid.
 */
export function fnv1a64(value: string): string {
  // Four 16-bit words hold the 64-bit hash without using slower BigInt math.
  let low = 0x2325;
  let midLow = 0x8422;
  let midHigh = 0x9ce4;
  let high = 0xcbf2;

  for (let i = 0; i < value.length; i++) {
    low ^= value.charCodeAt(i);
    const lowProduct = low * 435;
    const midLowProduct = midLow * 435 + (lowProduct >>> 16);
    const midHighProduct = midHigh * 435 + (low << 8);
    const highProduct = high * 435 + (midLow << 8);
    const midHighProductWithCarry = midHighProduct + (midLowProduct >>> 16);

    low = lowProduct & 0xffff;
    midHigh = midHighProductWithCarry & 0xffff;
    midLow = midLowProduct & 0xffff;
    high = (highProduct + (midHighProductWithCarry >>> 16)) & 0xffff;
  }

  return (
    HEX_BYTES[high >> 8] +
    HEX_BYTES[high & 0xff] +
    HEX_BYTES[midHigh >> 8] +
    HEX_BYTES[midHigh & 0xff] +
    HEX_BYTES[midLow >> 8] +
    HEX_BYTES[midLow & 0xff] +
    HEX_BYTES[low >> 8] +
    HEX_BYTES[low & 0xff]
  );
}
